import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  scroller: {
    overflowX: 'auto',
    border: '1px solid var(--border)',
    borderRadius: '8px',
    backgroundColor: 'var(--white)'
  } satisfies SxProps<Theme>,
  headerCell: {
    textTransform: 'uppercase',
    color: 'text.secondary',
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '0.04em',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  } satisfies SxProps<Theme>,
  headerLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    verticalAlign: 'middle'
  } satisfies SxProps<Theme>,
  row: {
    '&:last-child td': { borderBottom: 0 }
  } satisfies SxProps<Theme>,
  cell: {
    py: '12px'
  } satisfies SxProps<Theme>
}
